import { AppRoutes } from '@/shared/lib/routes';
import { env } from '@/config/env';
import { LegalLink } from '@/shared/components/legal-link';
import { LogoMarquee } from './logo-marquee';
import closingPattern from '../assets/bg-closing-pattern.webp';

interface CheckoutClosingProps {
  onCta: () => void;
}

export function CheckoutClosing({ onCta }: CheckoutClosingProps) {
  return (
    <section className="relative overflow-hidden bg-mf-neutral-900 px-4 pb-5 pt-10">
      <img
        src={closingPattern}
        alt=""
        className="pointer-events-none absolute inset-x-0 bottom-0 h-[550px] w-full object-cover object-bottom"
      />

      <div className="relative flex flex-col gap-10">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-2">
            <h2 className="font-display text-[28px] font-bold leading-9 text-white">
              Get Paid What
              <br />
              <span className="text-mf-green">You&apos;re Already Owed</span>
            </h2>
            <p className="text-base leading-5 text-mf-neutral-400">
              Companies are sitting on money that&apos;s already yours. We find it and handle the
              rest.
            </p>
          </div>

          <div className="-mx-4">
            <LogoMarquee />
          </div>

          <button
            type="button"
            onClick={onCta}
            className="flex h-[52px] w-full items-center justify-center rounded-full bg-mf-green text-[15px] font-bold leading-5 text-mf-neutral-50 transition-opacity hover:opacity-90"
          >
            Track & save
          </button>
        </div>

        <footer className="flex flex-col gap-2">
          <p className="text-center text-xs leading-4 text-mf-neutral-400">
            All rights reserved. {new Date().getFullYear()}
          </p>
          <div className="h-px w-full bg-[#2d2823]" />
          <div className="flex w-full flex-wrap items-start gap-x-0.5 gap-y-1 text-center text-xs leading-4 text-mf-neutral-400">
            <LegalLink
              to={AppRoutes.PRIVACY}
              target="_blank"
              rel="noopener noreferrer"
              className="min-w-[74px] flex-1 hover:text-white"
            >
              Privacy Policy
            </LegalLink>
            <LegalLink
              to={AppRoutes.TERMS}
              target="_blank"
              rel="noopener noreferrer"
              className="min-w-[67px] flex-1 hover:text-white"
            >
              Terms of use
            </LegalLink>
            <LegalLink
              to={AppRoutes.COOKIES}
              target="_blank"
              rel="noopener noreferrer"
              className="min-w-[71px] flex-1 hover:text-white"
            >
              Cookie Policy
            </LegalLink>
            {env.VITE_REFUND_URL ? (
              <a
                href={env.VITE_REFUND_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="min-w-[77px] flex-1 hover:text-white"
              >
                Ask for refund
              </a>
            ) : null}
          </div>
        </footer>
      </div>
    </section>
  );
}
